import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'

export const HeaderWrapper = styled(Box)(({ theme }) => (`
  background: ${theme.components.BreadCrumb.styleOverrides.background};
  display: flex;
  justify-content: space-between;
  transition: ${theme.transition};
  align-items: center;
  padding: 15px;
  position: relative;
  z-index:1;
`))

export const ButtonWrapper = styled(Box)(`
  display: flex;
  align-items: center;
  & button {
    margin-left:15px;
  }
`)

export const PageHeading = styled(Typography)(`
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  display: flex;
  align-items: center;
  margin-left: 5px;

  & img { margin-right: 10px; max-height:45px; }
`)

export const Message = styled(Typography)(props => `
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-left: 5px;
  color: ${props.type === 'error' ? 'red' : 'green'};
`)

export const SubmitOverlay = styled(Box)(`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
`)
